import { selectedSyncWindowSelector, setSelectedSyncWindow } from '@/redux/features/welcome.slice';
import type { OnboardingSyncWindowDays } from '@/types/historical-sync';
import { BlockStack, Button, Icon, InlineStack, Text } from '@shopify/polaris';
import { CheckCircleIcon } from '@shopify/polaris-icons';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

const OPTIONS: { label: string; value: OnboardingSyncWindowDays; recommended?: boolean }[] = [
  { label: 'No past orders', value: 0 },
  { label: 'Last 7 days', value: 7, recommended: true },
  { label: 'Last 30 days', value: 30 },
];

const OptionColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;

const SelectableButton = styled.div<{ $active: boolean }>`
  .Polaris-Button {
    ${({ $active }) =>
      $active
        ? `
          background: #ebf5ff;
          border: 1px solid #0070f3;
          color: #0070f3;
          box-shadow: none;
        `
        : `
          background: #f1f2f3;
          border: 1px solid transparent;
          box-shadow: none;
        `}
  }
`;

const SyncOrdersStep = () => {
  const dispatch = useDispatch();
  const selected = useSelector(selectedSyncWindowSelector);

  const handleSelect = useCallback(
    (value: OnboardingSyncWindowDays) => {
      dispatch(setSelectedSyncWindow(value));
    },
    [dispatch],
  );

  return (
    <BlockStack gap="1000" inlineAlign="center">
      <InlineStack gap="200" align="center" blockAlign="start">
        {OPTIONS.map((option) => {
          console.log("🚀 ~ SyncOrdersStep ~ CheckCircleIcon:", CheckCircleIcon)
          return (
            <OptionColumn key={option.value}>
              <SelectableButton $active={selected === option.value}>
                <Button size="large" onClick={() => handleSelect(option.value)}>
                  {option.label}
                </Button>
              </SelectableButton>
              {option.recommended && selected === option.value && (
                <InlineStack gap="100" blockAlign="center">
                  <Icon source={CheckCircleIcon} tone="success" />
                  <Text as="span" tone="success" fontWeight="semibold">
                    Recommended
                  </Text>
                </InlineStack>
              )}
            </OptionColumn>
          );
        })}
      </InlineStack>

      <Text as="p" tone="subdued" alignment="center">
        Syncing runs in the background. You can continue.
      </Text>
    </BlockStack>
  );
};

export default SyncOrdersStep;
